import { Form, Modal } from "react-bootstrap";
import LoadingButton from "../../../components/loading/LoadingButton";
import { useMutation } from "@tanstack/react-query";
import { putAuthMethod } from "../../../modules/helper";
import { useState } from "react";
import Swal from "sweetalert2";

function ModalTicketAnswer({ ticket, close, refetch }) {
  const { isPending: isLoading, mutate } = useMutation({
    mutationKey: ["supervisor-ticket-answer"],
    mutationFn: () =>
      putAuthMethod("/supervisor/v1/ticket-answer", {
        id: ticket.id,
        answer,
      }).then(res => res.data),

    onError: res =>
      Swal.fire({
        icon: "error",
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
        text: res.response?.data?.message ?? "خطا در ارتباط با سرور",
      }),

    onSuccess: res =>
      Swal.fire({
        icon: "success",
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "green",
        text: res.message,
      }).then(() => {
        close();
        refetch();
      }),
  });

  const [answer, setAnswer] = useState("");

  return (
    <Modal show={true} centered={true} size="lg">
      <Modal.Header>
        <h5>پاسخ دادن به تیکت</h5>
      </Modal.Header>

      <Modal.Body>
        <p>
          <strong>موضوع:</strong>
          <span> {ticket.subject} </span>

          <strong className="me-4">پیام:</strong>
          <span> {ticket.message}</span>
        </p>

        <div>
          <Form.Label>پاسخ:</Form.Label>
          <Form.Control
            as="textarea"
            onChange={e => setAnswer(e.target.value)}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        {isLoading && (
          <LoadingButton className="btn-primary" title="در حال ارسال" />
        )}
        {isLoading === false && (
          <button
            className="btn btn-primary"
            onClick={() => {
              if (answer.length === 0) {
                Swal.fire({
                  icon: "error",
                  text: "پاسخ نمی‌تواند خالی باشد",
                  cancelButtonText: "متوجه شدم",
                  confirmButtonColor: "gray",
                });
                return;
              }

              mutate();
            }}
          >
            ارسال
          </button>
        )}

        <button className="btn btn-danger" onClick={close}>
          بستن
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalTicketAnswer;
